<template>
  <div id="grid-validadores">
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text">Validadores</v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <carga-masiva
        v-if="usuarioLoggedTipe != 'AGENCIA'"
        :apiValidateDocument="apiValidateDocument"
        :apiSaveDocument="apiSaveDocument"
        :apiDownloadDocument="apiDownloadDocument"
        :templateTitle="templateTitle"
        :tipoCarga="tipoCarga"
      ></carga-masiva>
      <v-layout justify-center>
        <v-flex xs12 md3>
          <v-text-field
            v-model="rutValue"
            label="RUT sin puntos con guión"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="nombreValue" label="Nombre"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaFormatted"
                label="Fecha de creación"
                prepend-icon="event"
                @click="menu1 = !menu1"
                @blur="fechaValue = parseDate(fechaFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaValue"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md3>
          <v-select
            v-model="estadoValue"
            :items="estadoSelect"
            label="Estado"
            item-text="nombre"
            item-value="code"
          >
          </v-select>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadDataAprobados(true)"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsHabilitados"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-left">{{ props.item.rut }}</td>
                  <td class="text-xs-left">{{ props.item.nombre }}</td>
                  <td class="text-xs-left">{{ props.item.fecha_creacion }}</td>
                  <td
                    class="text-xs-left"
                    v-if="props.item.fechaCambioEstado != null"
                  >
                    {{ props.item.fechaCambioEstado }}
                  </td>
                  <td
                    class="text-xs-left"
                    v-if="props.item.fechaCambioEstado == null"
                  >
                    &nbsp;
                  </td>
                  <td class="text-xs-left">{{ props.item.observaciones }}</td>
                  <td class="text-xs-left">{{ props.item.estadoStr }}</td>
                  <td>
                    <v-btn
                      v-if="props.item.activado"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="grey darken-4"
                      small
                      title="Deshabilitar Validador"
                      @click="showModalDeshabilitar(props.item.id)"
                    >
                      <v-icon>toggle_on</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!props.item.activado"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="green darken-4"
                      small
                      title="Habilitar Validador"
                      @click="showModalHabilitar(props.item.id)"
                    >
                      <v-icon>toggle_off</v-icon>
                    </v-btn>
                    <v-btn
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      title="Editar validador"
                      @click="
                        editarValidador(
                          props.item.id,
                          props.item.rut,
                          props.item.nombre
                        )
                      "
                    >
                      <v-icon>open_in_new</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <!-- LEYENDA -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                v-if="usuarioLoggedTipe != 'PROVEEDOR'"
                depressed
                outline
                icon
                fab
                dark
                color="grey darken-4"
                small
                title="Deshabilitar Validador"
              >
                <v-icon>toggle_on</v-icon></v-btn
              >
              &nbsp;Desactivar Validador
              <v-btn
                v-if="usuarioLoggedTipe != 'PROVEEDOR'"
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
                title="Habilitar Validador"
              >
                <v-icon>toggle_off</v-icon></v-btn
              >
              &nbsp;Activar Validador
              <v-btn
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                title="Editar validador"
              >
                <v-icon>open_in_new</v-icon> </v-btn
              >&nbsp; Editar validador
            </v-card-actions>
            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="totalRegs"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pages"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>

            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                :disabled="botonDescarga"
                color="primary"
                @click="descarga()"
                >Descarga<v-icon right dark>folder</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </template>

          <v-dialog v-model="dialogLoading" persistent max-width="390">
            <loading-descarga></loading-descarga>
          </v-dialog>
        </v-flex>
      </v-layout>

      <!-- VALIDADORES POR APROBAR -->
      <v-layout style="padding-top: 30px; padding-bottom: 20px">
        <v-toolbar color="white" dark flat dense cad class="fill-height">
          <v-toolbar-title class="indigo--text"
            >Validadores por aprobar</v-toolbar-title
          >
          <v-btn
            color="primary"
            @click="crearValidador()"
            v-if="usuarioLoggedTipe != 'AGENCIA'"
          >
            Agregar validador</v-btn
          >
        </v-toolbar>
      </v-layout>
      <v-layout
        style="
          background-color: rgb(237, 237, 237);
          width: 100%;
          display: flex;
          align-items: center;
        "
      >
        <v-flex xs4 style="display: flex; align-items: center">
          <span class="title">Aprobación masiva</span>&nbsp;
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon dark color="grey" x-small v-bind="attrs" v-on="on"
                >help</v-icon
              >
            </template>
            <span
              >Se aprobarán todos los validadores seleccionados. Para
              seleccionar/deseleccionar todos, se debe presionar la casilla
              ubicada en la cabecera de la tabla.</span
            >
          </v-tooltip>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs4 style="display: flex; justify-content: flex-end">
          <v-btn
            v-if="usuarioLoggedTipe != 'PROVEEDOR'"
            style="width: auto"
            class="btnValidarCargaMasiva"
            title="Aprobar"
            :disabled="!selected.length"
            @click="aprobacionMasiva"
            >Aprobar ({{ selected.length }})</v-btn
          >
        </v-flex>
      </v-layout>
      <div v-if="loadingAprobacionMasiva">
        <loading></loading>
      </div>
      <!-- buscador por aprobar -->
      <v-layout justify-center>
        <v-flex xs12 md3>
          <v-text-field
            v-model="rutPorAprobarValue"
            label="RUT sin puntos con guión"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field
            v-model="nombrePorAprobarValue"
            label="Nombre"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1PorAprobar"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaPorAprobarFormatted"
                label="Fecha de creación"
                prepend-icon="event"
                @click="menu1PorAprobar = !menu1PorAprobar"
                @blur="
                  fechaPorAprobarValue = parseDate(fechaPorAprobarFormatted)
                "
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaPorAprobarValue"
              @input="menu1PorAprobar = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadDataPorAprobar(true)"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clearPorAprobar()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12 md12>
          <div v-if="loadingPorAprobar">
            <loading></loading>
          </div>
          <div v-if="alertaPorAprobar">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              v-model="selected"
              :headers="headersPorAprobar"
              :items="itemsPorAprobar"
              select-all
              item-key="id"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    class="text-xs-left"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr
                  :active="props.selected"
                  @click="props.selected = !props.selected"
                >
                  <td>
                    <v-checkbox
                      :input-value="props.selected"
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ props.item.rut }}</td>
                  <td class="text-xs-left">{{ props.item.nombre }}</td>
                  <td class="text-xs-left">
                    {{ props.item.fecha_modificacion }}
                  </td>
                  <td>
                    <v-btn
                     v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="green darken-4"
                      small
                      title="Habilitar"
                      @click="aprobar(props.item.id)"
                    >
                      <v-icon>toggle_off</v-icon>
                    </v-btn>
                    <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="primary"
                      small
                      title="Editar validador"
                      @click="
                        editarValidador(
                          props.item.id,
                          props.item.rut,
                          props.item.nombre
                        )
                      "
                    >
                      <v-icon>open_in_new</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
                      depressed
                      outline
                      icon
                      fab
                      dark
                      color="red"
                      small
                      title="Eliminar"
                      @click="eliminar(props.item.id)"
                    >
                      <v-icon>clear</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>
          <!-- LEYENDA -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn
              v-if="(usuarioLoggedTipe == 'AGENCIA' || usuarioLoggedTipe == 'ADMINISTRADOR') && getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
              depressed
              outline
              icon
              fab
              dark
              color="green darken-4"
              small
              title="Habilitar"
            >
              <v-icon>toggle_off</v-icon></v-btn
            >
            &nbsp;Habilitar
            <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
              depressed
              outline
              icon
              fab
              dark
              color="primary"
              small
              title="Editar validador"
            >
              <v-icon>open_in_new</v-icon> </v-btn
            >&nbsp; Editar validador
            <v-btn v-if="getCodigoPerfil() != 'LEC' && !isContratoCerrado()"
              clear
              depressed
              outline
              icon
              fab
              dark
              color="red"
              small
              title="Eliminar"
            >
              <v-icon>clear</v-icon></v-btn
            >
            &nbsp;Eliminar
          </v-card-actions>
          <!-- paginacion por aprobar -->
          <v-layout
            row
            wrap
            align-center
            style="display: flex; align-items: center"
          >
            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="totalRegsPorAprobar"
                disabled
              ></v-text-field>
            </v-flex>
            <!-- <v-flex xs12 sm6 class="text-right justify-end"> -->
            <v-flex xs12 sm6 style="display: flex; justify-content: flex-end">
              <div class="d-inline-block">
                <v-select
                  v-model="nItemsPorAprobar"
                  :items="nItemsPorAprobarOptions"
                  label="Registros por página"
                  dense
                  @change="loadDataPorAprobar(true)"
                ></v-select>
              </div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs4 style="display: flex; justify-content: flex-start">
              <!-- <div class="text-center pt-2"> -->
              <v-pagination
                @input="changePagePorAprobar(pagePorAprobar)"
                v-model="pagePorAprobar"
                :length="pagesPorAprobar"
                :total-visible="9"
                circle
              ></v-pagination>
            </v-flex>
            <!-- </div> -->
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- Dialog validador-->
      <v-form ref="form" lazy-validation>
        <v-dialog v-model="dialogCrear" max-width="500">
          <v-card>
            <v-flex xs10 class="mx-4">
              <v-card-title class="headline" style="font-weight: bold"
                >Datos validador</v-card-title
              >
              <v-text-field
                v-model="rut"
                :error-messages="rutErrors"
                label="RUT sin puntos con guión"
                counter
                maxlength="11"
                @input="$v.rut.$touch()"
                @blur="$v.rut.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="nombre"
                :error-messages="nombreErrors"
                label="Nombre"
                counter
                maxlength="70"
                @input="$v.nombre.$touch()"
                @blur="$v.nombre.$touch()"
              ></v-text-field>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="indigo darken-1" flat="flat" @click="cerrarDialog"
                  >Cancelar</v-btn
                >
                <v-btn
                  color="indigo darken-1"
                  flat="flat"
                  @click="saveValidador()"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-form>

      <!-- MODAL DESHABILITAR -->
      <v-form ref="form" lazy-validation>
        <v-dialog v-model="modalDeshabilitar" max-width="500">
          <v-card>
            <v-flex xs10 class="mx-4">
              <v-card-title class="headline" style="font-weight: bold"
                >Deshabilitar validador</v-card-title
              >
              <v-textarea
                name="input-7-1"
                v-model="observaciones"
                label="Observaciones"
                value
                counter
                maxlength="500"
              ></v-textarea>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="indigo darken-1" flat="flat" @click="cerrarModal"
                  >Cancelar</v-btn
                >
                <v-btn color="primary" @click="deshabilitar()"
                  >Deshabilitar</v-btn
                >
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-form>
      <!-- MODAL HABILITAR -->
      <v-form ref="form" lazy-validation>
        <v-dialog v-model="modalHabilitar" max-width="500">
          <v-card>
            <v-flex xs10 class="mx-4">
              <v-card-title class="headline" style="font-weight: bold"
                >Habilitar validador</v-card-title
              >
              <v-textarea
                name="input-7-1"
                v-model="observaciones"
                label="Observaciones"
                value
                counter
                maxlength="500"
              ></v-textarea>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="indigo darken-1" flat="flat" @click="cerrarModal"
                  >Cancelar</v-btn
                >
                <v-btn color="primary" @click="habilitar()">Habilitar</v-btn>
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-dialog>
      </v-form>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { misMixins } from "@/mixins/myMixing.js";
import jwtDecode from "jwt-decode";

export default {
  name: "grid-validadores",

  components: {
    AlertEmpty,
    Loading,
    CargaMasiva,
    LoadingDescarga,
  },
  mixins: [misMixins, validationMixin],
  validations: {
    nombre: { required },
    rut: { required },
  },
  props: {},

  data() {
    return {
      botonDescarga: true,
      loading: false,
      alerta: false,
      loadingPorAprobar: false,
      alertaPorAprobar: false,
      dialog: false,
      dialogLoading: false,
      usuarioLoggedTipe: "",
      idContrato: "",
      headers: [
        { text: "RUT", align: "left", sortable: false, value: "rut" },
        { text: "Nombre", sortable: false, value: "Nombre" },
        { text: "Fecha de creación", sortable: false, value: "registro" },
        {
          text: "Fecha cambio estado",
          sortable: false,
          value: "deshabilitacion",
        },
        { text: "Observaciones", sortable: false, value: "Observaciones" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Acción", sortable: false, value: "" },
      ],
      itemsHabilitados: [],
      //primer buscador
      estadoSelect: [],
      estadoValue: null,
      nombreValue: null,
      rutValue: null,
      fechaValue: null,
      menu1: false,
      fechaFormatted: null,

      //----CARGA MASIVA---
      apiValidateDocument: "/validaciones/preProcessValidadores",
      apiSaveDocument: "/validaciones/saveFileValidadores",
      apiDownloadDocument: "/validaciones/downloadTemplateValidadores/",
      templateTitle: "Plantilla_Carga_Validadores",
      tipoCarga: "CSV",

      //paginacion primera tabla DB
      page: 1,
      pages: 1,
      totalRegs: 0,
      rowsPerPageItems: [20],

      //nuevo validador
      idValidador: -1,
      rut: "",
      nombre: "",
      dialogCrear: false,

      //cambio estado
      idValidadorEstado: -1,
      observaciones: "",
      modalHabilitar: false,
      modalDeshabilitar: false,

      /*aprobacion masiva */
      loadingAprobacionMasiva: false,
      selected: [],
      itemsPorAprobar: [
        // Ejemplo de datos
        // { id: 1, rut: '12345678-9', nombre: 'Juan Perez', fecha_modificacion: '2023-01-01' },
        // { id:2, rut: '98765432-1', nombre: 'Maria Lopez', fecha_modificacion: '2023-01-02' },
      ],
      headersPorAprobar: [
        { text: "RUT", align: "left", sortable: false, value: "rut" },
        { text: "Nombre", sortable: false, value: "nombre" },
        {
          text: "Fecha de creación",
          sortable: false,
          value: "fecha_modificacion",
        },
        { text: "Acción", sortable: false, value: "accion" },
      ],
      //segundo buscador
      nombrePorAprobarValue: null,
      rutPorAprobarValue: null,
      fechaPorAprobarValue: null,
      menu1PorAprobar: false,
      fechaPorAprobarFormatted: null,
      //segunda tabla, DB, pro aprobar
      pagePorAprobar: 1,
      pagesPorAprobar: 1,
      totalRegsPorAprobar: 0,
      nItemsPorAprobar: 20,
      nItemsPorAprobarOptions: [20, 50, 100],
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;

      setTimeout(() => (this.dialogLoading = false), 5000);
    },
    fechaValue() {
      this.fechaFormatted = this.formatDate(this.fechaValue);
    },
    fechaPorAprobarValue(val) {
      this.fechaPorAprobarFormatted = this.formatDate(
        this.fechaPorAprobarValue
      );
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.loadEstados();
    this.loadDataAprobados(true);
    this.loadDataPorAprobar();
  },
  mounted() {},
  computed: {
    rutErrors() {
      const errors = [];
      if (!this.$v.rut.$dirty) return errors;
      !this.$v.rut.required && errors.push("Rut es obligatorio.");
      this.$v.rut.$model.length > 11 &&
        errors.push("El RUT debe tener como máximo 11 caracteres.");
      if (!this.validaRut(this.rut)) {
        errors.push("Rut inválido");
      }
      return errors;
    },
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    async loadListaEstados() {
      return await axios
        .post("/validaciones/loadListaEstados/")
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log("error: loadListaEstados:" + error.response);
          }
          return -1;
        });
    },
    async loadEstados() {
      let estados = await this.loadListaEstados();

      let est = [];
      estados.forEach(function (e) {
        est.push({
          nombre: e.nombre,
          code: e.id,
        });
      });
      this.estadoSelect = est;
    },
    descarga() {
      this.dialogLoading = true;
      let fileName = "Descarga_Validadores.xlsx";

      var url = "/validaciones/descargaValidadores";
      this.body = {
        idContrato: this.idContrato,
        nombre: this.nombreValue,
        rut: this.rutValue,
        fechaIni:
          this.fechaValue && this.fechaValue != null
            ? this.formatDate(this.fechaValue) + " 00:00"
            : null,
        estado: this.estadoValue,
      };
      axios
        .post(url, this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadValidadores() {
      this.body = {
        idContrato: this.idContrato,
        nombre: this.nombreValue,
        rut: this.rutValue,
        fechaIni:
          this.fechaValue && this.fechaValue != null
            ? this.formatDate(this.fechaValue) + " 00:00"
            : null,
        estado: this.estadoValue,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/validaciones/getValidadores/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(
              "falla loadValidadores:" + JSON.stringify(error, null, 2)
            );
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.message); */
          }
          return [];
        });
    },
    async loadData(limpiar) {
      //para que carga masiva recarque tabla de abajo: por aprobar
      this.loadDataPorAprobar(limpiar);
    },
    async loadDataAprobados(limpiar) {
      // console.log("loadData:" + limpiar);
      if (limpiar) this.page = 1;

      this.loading = true;
      let result = await this.loadValidadores();

      if (result.totalRegistros > 0) {
        this.itemsHabilitados = result.habilitados;
        this.totalRegs = result.totalRegistros;
        this.pages = Math.ceil(this.totalRegs / this.rowsPerPageItems);
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.itemsHabilitados = [];
        this.totalRegs = 0;
        this.page = 1;
        this.pages = 0;
        this.alerta = true;
        this.botonDescarga = true;
      }
      this.loading = false;
    },
    clear() {
      this.nombreValue = null;
      this.rutValue = null;
      this.fechaValue = null;
      this.estadoValue = null;
      this.loadDataAprobados(true);
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadDataAprobados(false);
    },
    //TODO tabla de arriba
    cerrarModal() {
      this.idValidadEstado = -1;
      this.observaciones = "";
      this.modalDeshabilitar = false;
      this.modalHabilitar = false;
    },
    showModalDeshabilitar(id) {
      this.idValidadorEstado = id;
      // console.log("showModalDeshabilitarrrrrrrrrrrrr:" + id + "::" + this.idValidadorEstado);
      this.observaciones = "";
      this.modalDeshabilitar = true;
    },
    showModalHabilitar(id) {
      this.idValidadorEstado = id;
      // console.log("showModalHabilitar:" + id + "::" + this.idValidadorEstado);
      this.observaciones = "";
      this.modalHabilitar = true;
    },
    deshabilitar() {
      this.body = {
        idContrato: this.idContrato,
        idValidador: this.idValidadorEstado,
        observaciones: this.observaciones,
      };
      this.cerrarModal();
      axios
        .post("/validaciones/deshabilitaValidador/", this.body)
        .then(() => {
          window.getApp.$emit("APP_SAVE");
          this.loadDataAprobados(true);
          // this.loadDataPorAprobar();
        })
        .catch((error) => {
          if (error) {
            // console.log("bb:" + error);
            window.getApp.$emit("APP_PROCESS_ERROR");
          }
        });
    },
    habilitar() {
      this.body = {
        idContrato: this.idContrato,
        idValidador: this.idValidadorEstado,
        observaciones: this.observaciones,
      };
      this.cerrarModal();
      axios
        .post("/validaciones/habilitaValidador/", this.body)
        .then(() => {
          window.getApp.$emit("APP_SAVE");
          this.loadDataAprobados(true);
          // this.loadDataPorAprobar();
        })
        .catch((error) => {
          if (error) {
            // console.log("cc:" + error);
            window.getApp.$emit("APP_PROCESS_ERROR");
          }
        });
    },

    //
    //TODO tabla de abajo
    //
    cerrarDialog() {
      this.dialogCrear = false;
      this.idValidador = -1;
      this.rut = "";
      this.nombre = "";
    },
    aprobar(idValidador) {
      this.body = {
        idContrato: this.idContrato,
        idValidador: idValidador,
      };
      this.cerrarDialog();
      axios
        .post("/validaciones/aprobarValidador/", this.body)
        .then(() => {
          window.getApp.$emit("APP_SAVE");
          this.loadDataAprobados(true);
          this.loadDataPorAprobar();
        })
        .catch((error) => {
          if (error) {
            // console.log("dd:" + error.response);
            window.getApp.$emit("APP_PROCESS_ERROR");
          }
        });
    },
    eliminar(idValidador) {
      this.body = {
        idContrato: this.idContrato,
        idValidador: idValidador,
      };
      axios
        .post("/validaciones/eliminarValidador/", this.body)
        .then(() => {
          window.getApp.$emit("APP_SAVE");
          this.loadDataAprobados(true);
          this.loadDataPorAprobar();
        })
        .catch((error) => {
          if (error) {
            // console.log("ee:" + error.response);
            window.getApp.$emit("APP_PROCESS_ERROR");
          }
        });
    },
    //datos por aprobar, CON paginacion
    async loadValidadoresPorAprobar() {
      this.body = {
        idContrato: this.idContrato,
        nombre: this.nombrePorAprobarValue,
        rut: this.rutPorAprobarValue,
        fechaIni:
          this.fechaPorAprobarValue && this.fechaPorAprobarValue != null
            ? this.formatDate(this.fechaPorAprobarValue) + " 00:00"
            : null,
        pageSize: this.nItemsPorAprobar,
        pageNumber: this.pagePorAprobar,
      };
      return await axios
        .post("/validaciones/getValidadoresPorAprobar/", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            // console.log("ff:" + error.response);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.message); */
          }
          return [];
        });
    },
    async loadDataPorAprobar(limpiar) {
      if (limpiar) this.pagePorAprobar = 1;

      this.loadingPorAprobar = true;
      let result = await this.loadValidadoresPorAprobar();

      if (result.totalRegistros > 0) {
        this.itemsPorAprobar = result.porHabilitar;
        this.totalRegsPorAprobar = result.totalRegistros;
        this.pagesPorAprobar = Math.ceil(
          this.totalRegsPorAprobar / this.nItemsPorAprobar
        );
        this.alertaPorAprobar = false;
      } else {
        this.itemsPorAprobar = [];
        this.totalRegsPorAprobar = 0;
        this.pagePorAprobar = 1;
        this.pagesPorAprobar = 0;
        this.alertaPorAprobar = true;
      }

      this.loadingPorAprobar = false;
    },
    crearValidador() {
      this.idValidador = -1;
      this.rut = "";
      this.nombre = "";
      this.dialogCrear = true;
    },
    editarValidador(id, rut, nombre) {
      this.idValidador = id;
      this.rut = rut;
      this.nombre = nombre;
      this.dialogCrear = true;
    },
    saveValidador() {
      this.dialogCrear = false;
      if (
        this.nombre == undefined ||
        this.nombre == null ||
        this.nombre == "" ||
        this.rut == undefined ||
        this.rut == null ||
        this.rut == ""
      ) {
        window.getApp.$emit("DATOS_INCOMPLETOS");
        return;
      }
      if (!this.validaRut(this.rut)) {
        window.getApp.$emit("ERROR_RUT");
        return;
      }

      this.loading = true;
      this.body = {
        id: this.idValidador,
        idContrato: this.idContrato,
        rut: this.rut,
        nombre: this.nombre,
      };

      axios
        .post("/validaciones/saveValidador", this.body)
        .then(() => {
          // console.log("saveValidador ok:");
          window.getApp.$emit("APP_SAVE");
          this.nombre = "";
          this.idValidador = -1;
          this.rut = "";
          this.loading = false;
          this.loadDataAprobados();
          this.loadDataPorAprobar();
        })
        .catch((error) => {
          // console.log("error:" + JSON.stringify(error, null, 2));
          if (error) {
            console.log(
              "falla saveValidador:" + JSON.stringify(error.response, null, 2)
            );
            if (error.response.data.code == 422)
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            else window.getApp.$emit("ERROR_EXCEPTION_BACK");
          } else {
            console.log("error saveValidador");
            window.getApp.$emit("ERROR_EXCEPTION_BACK");
          }
          this.loading = false;
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    //TODO AprobacionMasiva
    clearPorAprobar() {
      this.nombrePorAprobarValue = null;
      this.rutPorAprobarValue = null;
      this.fechaPorAprobarValue = null;
      this.loadDataPorAprobar(true);
    },
    changePagePorAprobar(page) {
      console.log("changePagePorAprobar:" + page + "::" + this.pagesPorAprobar);
      this.pagePorAprobar =
        page <= 0 || page > this.pagesPorAprobar ? this.pagePorAprobar : page;
      console.log("changePagePorAprobar2:" + this.pagePorAprobar);
      this.loadDataPorAprobar(false);
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.itemsPorAprobar.slice();
    },
    async aprobacionMasiva() {
      // console.log("st::aprobacionMasiva:" + JSON.stringify(this.selected, null, 2));
      try {
        const selectedIds = this.selected.map((item) => item.id);

        axios
          .post(
            "/validaciones/aprobacionMasiva/" + this.idContrato,
            selectedIds
          )
          .then(() => {
            // console.log("saveValidador ok:");
            window.getApp.$emit("APP_SAVE");
            this.selected = [];
            this.loadingAprobacionMasiva = false;
            this.loadDataAprobados();
            this.loadDataPorAprobar();
          })
          .catch((error) => {
            // console.log("error:" + JSON.stringify(error, null, 2));
            if (error) {
              console.log(
                "falla aprobacionMasiva:" +
                  JSON.stringify(error.response, null, 2)
              );
              if (error.response.data.code == 422)
                window.getApp.$emit(
                  "ERROR_EXCEPTION",
                  error.response.data.message
                );
              else window.getApp.$emit("ERROR_EXCEPTION_BACK");
            } else {
              console.log("error aprobacionMasiva");
              window.getApp.$emit("ERROR_EXCEPTION_BACK");
            }
            this.loadingAprobacionMasiva = false;
          });
      } catch (error) {
        console.error("Error al enviar los datos:", error);
      }
    },
  },
};
</script>